import React from "react";
import Blogs from "../../sections/BlogsSection/Blogs/blogs";

const Blogspage=()=>{
    return(
        <div>
         <Blogs/>
        </div>
    )
}

export default Blogspage